import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
import Layout from '@/Shared/Layout';
import Pagination from '@/Shared/Pagination';
import SearchFilter from '@/Shared/SearchFilter';
import { Link } from '@inertiajs/inertia-vue3';
import Editor from "@/Shared/Editor.vue";
import TagsInput from '@/Shared/TagsInput.vue';

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  components: {
    Head: Head,
    Icon: Icon,
    Pagination: Pagination,
    SearchFilter: SearchFilter,
    Link: Link,
    Editor: Editor,
    TagsInput: TagsInput
  },
  layout: Layout,
  props: {
    tenantList: {
      type: Object,
      "default": {}
    },
    authUser: {
      type: Object,
      "default": {}
    }
  },
  data: function data() {
    return {
      selectedTenant: "",
      campaignList: {},
      selectedCampaign: "",
      isLoadingDrafts: false,
      cadence: {},
      currentFollowUp: 0,
      showPreview: false,
      preview_subject: '',
      preview_body: '',
      previewMailTo: [this.$page.props.auth.user.email]
    };
  },
  methods: {
    updatecampaignList: function updatecampaignList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.loading = true;
                _this.cadence = {};
                _this.campaignList = {};
                _this.selectedCampaign = "";
                _context.next = 6;
                return axios.post('/drafts/campaignList', {
                  'tenantId': _this.selectedTenant
                });
              case 6:
                res = _context.sent;
                if (res.data.status == "success") {
                  _this.campaignList = res.data.campaignList;
                } else {
                  ElMessage({
                    showClose: true,
                    message: res.data.message,
                    type: res.data.status
                  });
                }
                _this.$store.loading = false;
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    updateCadence: function updateCadence() {
      this.cadence = {};
    },
    getDrafts: function getDrafts() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLoadingDrafts = true;
                _this2.cadence = {};
                _context2.next = 4;
                return axios.post('/drafts/data', {
                  'tenantId': _this2.selectedTenant,
                  'campaignId': _this2.selectedCampaign
                });
              case 4:
                res = _context2.sent;
                if (res.data.status == "success") {
                  _this2.cadence = res.data.cadence;
                  _this2.currentFollowUp = 0;
                } else {
                  ElMessage({
                    showClose: true,
                    message: res.data.message,
                    type: res.data.status
                  });
                }
                _this2.isLoadingDrafts = false;
              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getCntrId: function getCntrId(f_id) {
      return 'follow_' + f_id + '_cntr';
    },
    getEditorRef: function getEditorRef(f_id) {
      return 'follow_' + f_id;
    },
    saveDraft: function saveDraft(f_key) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$store.loading = true;
                _context3.next = 3;
                return axios.post('/drafts/store/' + _this3.selectedCampaign, {
                  'tenantId': _this3.selectedTenant,
                  'followUp': _this3.cadence.follow_ups[f_key]
                });
              case 3:
                res = _context3.sent;
                ElMessage({
                  showClose: true,
                  message: res.data.message,
                  type: res.data.status
                });
                _this3.$store.loading = false;
              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    showDraftPreview: function showDraftPreview(f_id) {
      this.preview_subject = this.cadence.follow_ups[f_id].subject;
      this.preview_body = this.cadence.follow_ups[f_id].body;
      this.preview_body = this.preview_body.replaceAll(/{{first_name}}/g, this.$page.props.auth.user.first_name).replaceAll(/{{last_name}}/g, this.$page.props.auth.user.last_name).replaceAll(/{{company_name}}/g, "Sample Company").replaceAll(/{{title}}/g, "Sample Title").replaceAll(/{{department}}/g, "Sample Department").replaceAll(/{{industry}}/g, "Sample Industry");
      this.preview_subject = this.preview_subject.replaceAll(/{{first_name}}/g, this.$page.props.auth.user.first_name).replaceAll(/{{last_name}}/g, this.$page.props.auth.user.last_name).replaceAll(/{{company_name}}/g, "Sample Company").replaceAll(/{{title}}/g, "Sample Title").replaceAll(/{{department}}/g, "Sample Department").replaceAll(/{{industry}}/g, "Sample Industry");
      this.showPreview = true;
    },
    sendPreviewMail: function sendPreviewMail() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var preview_data, res, status, resData;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                preview_data = {
                  'send_to': _this4.previewMailTo,
                  'subject': _this4.preview_subject,
                  'body': _this4.preview_body
                };
                _this4.$store.loading = true;
                _context4.prev = 2;
                status = '';
                _context4.next = 6;
                return axios.post('/drafts/preview/' + _this4.selectedCampaign, preview_data);
              case 6:
                res = _context4.sent;
                resData = res.data;
                status = resData['status'];
                if (status == 'success') {
                  ElMessage({
                    showClose: true,
                    message: "Mail sent successfully.",
                    type: 'success'
                  });
                }
                _context4.next = 15;
                break;
              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](2);
                res = _context4.t0.response;
              case 15:
                _context4.prev = 15;
                _this4.$store.loading = false;
                _this4.showPreview = false;
                return _context4.finish(15);
              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 12, 15, 19]]);
      }))();
    }
  }
};